import type { MarkTypeDef } from '@kancelaria/shared';
import { type ReactNode } from 'react';

/**
 * Кольори позначок віддаємо в CSS-змінних для обох тем одразу — тоді
 * перемикання світла/темряви не потребує перемальовування таблиці.
 */
export function MarkStyles({ types }: { types: MarkTypeDef[] }): ReactNode {
  // Приглушена пара для закритих замком днів. Саме колір, а не `opacity` чи
  // `filter`: ті створюють окремий шар на кожній клітинці, і лінійки під
  // курсором починають смикатися на тисячах комірок місяця.
  const pair = (bg: string, fg: string, code: string): string =>
    `--mk-${code}-bg:${bg};--mk-${code}-fg:${fg};` +
    `--mk-${code}-bg-off:color-mix(in srgb, ${bg} 38%, var(--panel));` +
    `--mk-${code}-fg-off:color-mix(in srgb, ${fg} 55%, var(--panel));`;

  const light = types.map(t => pair(t.color, t.textColor, t.code)).join('');
  const dark = types.map(t => pair(t.colorDark ?? t.color, t.textColorDark ?? t.textColor, t.code)).join('');
  return <style>{`:root{${light}}:root[data-theme='dark']{${dark}}`}</style>;
}
